var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "video-default-location-page-type-selector" },
    [
      _c("VDropdown", {
        attrs: { items: _vm.items },
        on: { change: _vm.onChange },
        scopedSlots: _vm._u([
          {
            key: "arrow",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "video-default-location-page-type-selector-icon",
                  },
                  [
                    _c("VIcon", {
                      attrs: { size: 15, icon: "mdi-chevron-down" },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.curItem,
          callback: function ($$v) {
            _vm.curItem = $$v
          },
          expression: "curItem",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }